import { nanoid } from 'nanoid';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ErrorMessageType } from '../utils/surveyStatusSchemas';

export const formatErrorsToText = (errors: ErrorMessageType[]) =>
    errors
        .map(error => {
            return `${[error.statusCode, error.title].join(': ')}\n${error.message}\n${error.correlationId ?? ''}`;
        })
        .join('\n\n');

export type ErrorStateType = {
    errors: Record<string, ErrorMessageType>;
    addError: (err: ErrorMessageType & { shouldLogInsights?: boolean }) => void;
    clearErrors: () => void;
    dismissError: (id: string) => void;
};

export const useErrorState = create(
    persist<ErrorStateType>(
        (set, get) => ({
            errors: {},

            addError: (err: ErrorMessageType & { shouldLogInsights?: boolean }) => {
                const id = err.id || err.correlationId || nanoid();

                const newErrors = {
                    ...get().errors,
                    [id]: { ...err, id },
                };

                set({
                    errors: newErrors,
                });
            },

            clearErrors: () => {
                set({
                    errors: {},
                });
            },

            dismissError: (id: string) => {
                const newErrors = {
                    ...get().errors,
                };
                delete newErrors[id];

                set({
                    errors: newErrors,
                });
            },
        }),
        {
            name: 'errors',
            storage: createJSONStorage(() => sessionStorage)        },
    ),
);
